import { render, staticRenderFns } from "./edibleVsInedibleWaste.vue?vue&type=template&id=6952f6d0"
import script from "./edibleVsInedibleWaste.js?vue&type=script&lang=js&external"
export * from "./edibleVsInedibleWaste.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports